/**
 * Component Registry for Amc Theme
 * 
 * Extends the base preferred theme registry with Amc specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-preferred/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { FeeGuide } from './components/FeeGuide';
import { AHScheduler } from './components/AHScheduler';
import { ScheduleATour } from './components/ScheduleATour';
import { ContactUs } from './components/ContactUs';
import { ApplyNow } from './components/ApplyNow';
import { ResidentAccess } from './components/ResidentAccess';
import { ApartmentSyncSection } from './components/ApartmentSyncSection';
import { CTASection } from './components/CTASection';
import { PropertyOverview } from './components/PropertyOverview';
import { NeighborhoodCallout } from './components/NeighborhoodCallout';
import { FloorplansList } from './components/FloorplansList';
import { ReviewsCallout } from './components/ReviewsCallout';
import { AmenitiesList } from './components/AmenitiesList';
import { PetPolicy } from './components/PetPolicy';
import { ThankYouContent } from './components/ThankYouContent';
import { FAQHero } from './components/FAQHero';
import { FAQList } from './components/FAQList';
import { SitemapContent } from './components/SitemapContent';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { Gallery } from './components/Gallery';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';

/**
 * Amc specific component overrides.
 * These components have been customized for the Amc brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const amcpreferredthemeOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const amcpreferredthemeOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  Hero,
  FeeGuide,
  AHScheduler,
  ScheduleATour,
  ContactUs,
  ApplyNow,
  ResidentAccess,
  ApartmentSyncSection,
  CTASection,
  PropertyOverview,
  NeighborhoodCallout,
  FloorplansList,
  ReviewsCallout,
  AmenitiesList,
  PetPolicy,
  ThankYouContent,
  FAQHero,
  FAQList,
  SitemapContent,
  SpecialOfferBanner,
  Gallery,
  VirtualTourEmbed,
};

/**
 * Final merged registry for Amc properties.
 * Inherits all components from the preferred theme, with Amc overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...amcpreferredthemeOverrides,
};

export default registry;
